import { defineStore } from "pinia";
import eventSettingsApi from "../Api/eventSettingsApi";
import verificationsApi from "../Api/verifications";
import { humanizeDuration } from "../Common/dateTimeUtils";

export const useVerificationStore = defineStore("verification", {
    state: () => ({
        eventId: 0,
        eventTimezone: "UTC",
        earlyVerificationBlocked: false,
        earlyVerificationPeriod: null as number | null,
        queueVerificationBlocked: false,
        queueVerificationLimit: null as number | null,
        autoDqWhenCategoryBeginsEnabled: false,
        requestsInProgress: 0,
    }),

    getters: {
        // Mirrors the backend which treats a limit lower than 1 as 1.
        effectiveQueueVerificationLimit: state => Math.max(1, state.queueVerificationLimit ?? 1),
        humanEarlyVerificationPeriod(): string {
            const minutes = this.earlyVerificationPeriod ?? 0;
            return humanizeDuration(minutes, "minutes", window.panelLocale);
        },
    },

    actions: {
        // For users who cannot read event settings (verification desk Staff).
        fetchVerificationSettings() {
            return verificationsApi.getVerificationSettings(this.eventId).then(settings => {
                this.earlyVerificationBlocked = settings.earlyVerificationBlocked;
                this.earlyVerificationPeriod = settings.earlyVerificationPeriod;
                this.queueVerificationBlocked = settings.queueVerificationBlocked;
                this.queueVerificationLimit = settings.queueVerificationLimit;
                this.autoDqWhenCategoryBeginsEnabled = settings.autoDqWhenCategoryBeginsEnabled;
            });
        },
        fetchEarlyVerificationsSettings() {
            return eventSettingsApi
                .listSettings(this.eventId, [
                    "earlyVerificationBlocked",
                    "earlyVerificationPeriod",
                    "queueVerificationBlocked",
                    "queueVerificationLimit",
                    "autoDqWhenCategoryBeginsEnabled",
                ])
                .then(settings => {
                    settings.forEach(setting => {
                        if (setting.name === "earlyVerificationBlocked") {
                            this.earlyVerificationBlocked = setting.value as boolean;
                        }
                        if (setting.name === "earlyVerificationPeriod") {
                            this.earlyVerificationPeriod = setting.value as number;
                        }
                        if (setting.name === "queueVerificationBlocked") {
                            this.queueVerificationBlocked = setting.value as boolean;
                        }
                        if (setting.name === "queueVerificationLimit") {
                            this.queueVerificationLimit = setting.value as number;
                        }
                        if (setting.name === "autoDqWhenCategoryBeginsEnabled") {
                            this.autoDqWhenCategoryBeginsEnabled = setting.value as boolean;
                        }
                    });
                });
        },
    },
});
